<template>
  <div class="popup-toast">
    <b-alert
      fade
      class="position-fixed fixed-bottom"
      :show="updateExists"
      @dismissed="updateExists = false"
      :dismissible="dismiss"
      variant="light"
    >
      <b-row>
        <b-col cols="1">
          <font-awesome-icon
            :icon="['fa', 'info-circle']"
            class="text-primary fs-18"
        /></b-col>
        <b-col cols="11">
          <h6 class="mb-2 fs-14">A new version is available.</h6>
          <span class="fs-12"
            >To update to the new version now
            <b-link @click="refreshApp">click here</b-link> to refresh.</span
          >
        </b-col>
        <!-- <b-button
        variant="primary"
        class="ml-4"
        href="javascript:void(0)"
        @click="refreshApp"
      >Refresh Now</b-button>-->
      </b-row>
    </b-alert>
  </div>
</template>

<script>
import update from "../mixins/update";
import { mapState } from "vuex";
export default {
  name: "update-app-alert",
  mixins: [update],
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    dismiss() {
      let check = false;
      if (
        this.state.billing.billing.cart.hasOwnProperty("data") &&
        this.state.billing.billing.cart.data.length > 0
      ) {
        check = true;
      }
      return check;
    },
  },
};
</script>

<style lang="scss" scoped></style>
